import { useContext } from "react";
import { RealtimeContext } from "@/contexts/RealtimeContext.js";

export function useRealtime() {
  return useContext(RealtimeContext);
}
